import CategoriesItem from "../CategoriesItem";
import Footer from "../Footer";
import Newsletter from "../Newsletter";

function All() {
  return (
    <>
      <CategoriesItem />
      <Newsletter />
      <Footer />
    </>
  );
}

export default All;
